import { heroStats, siteMeta, topics } from "@/mocks/guage";

export default function HeroSection() {
  const tickerItems = [
    "顶流塌房连环瓜",
    "综艺赛制临时改规则",
    "红毯生图大战",
    "直播间嘴瓢名场面",
    "剧集魔改原著被喷",
    "工作室文案大型自曝",
  ];

  return (
    <section id="top" className="relative w-full min-h-[100svh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={siteMeta.heroImage}
          alt="瓜哥吃瓜 娱乐神点评舞台灯光抽象背景"
          title="瓜哥吃瓜 · 神点评与犀利吐槽"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-accent-950/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 md:pt-36 pb-10 md:pb-14">
        <div className="w-full flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm backdrop-blur-sm">
            <i className="ri-fire-fill text-accent-400"></i>
            {siteMeta.tagline}
          </span>

          <h1 className="mt-5 md:mt-7 font-heading text-background-50 text-5xl sm:text-6xl md:text-8xl leading-[1.05] tracking-wide">
            {siteMeta.brand}
          </h1>

          <p className="mt-4 md:mt-6 max-w-2xl md:max-w-3xl text-background-50/90 text-sm md:text-lg leading-relaxed text-balance">
            瓜哥吃瓜神点评一针见血，犀利吐槽爆笑不断。名场面与金句弹幕高能频出，
            看热闹更看门道，每一条都让你直呼过瘾。
          </p>

          <div className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center gap-3">
            <a
              href="#roast"
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-alarm-warning-line"></i>
              看今天的热门神点评
            </a>
            <a
              href="#quotes"
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 border border-background-50/35 text-background-50 text-sm md:text-base font-medium whitespace-nowrap backdrop-blur-sm hover:bg-background-50/25 transition-colors cursor-pointer"
            >
              <i className="ri-chat-quote-line"></i>
              逛金句弹幕墙
            </a>
          </div>

          <div className="mt-9 md:mt-12 grid grid-cols-3 gap-4 md:gap-14 w-full max-w-2xl">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center">
                <span className="font-heading text-2xl md:text-4xl text-accent-400">{stat.value}</span>
                <span className="mt-1 text-[11px] md:text-sm text-background-50/75">{stat.label}</span>
              </div>
            ))}
          </div>

          <div className="mt-9 md:mt-12 flex flex-wrap items-center justify-center gap-2">
            {topics.slice(0, 5).map((topic) => (
              <a
                key={topic.name}
                href="#topics"
                className="px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50/90 text-xs md:text-sm whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                {topic.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-background-50/15 bg-black/35 backdrop-blur-sm overflow-hidden">
        <div className="flex w-max marquee-track py-3">
          {[0, 1].map((loop) => (
            <div key={loop} className="flex items-center">
              {tickerItems.map((item) => (
                <span key={`${loop}-${item}`} className="flex items-center text-background-50/80 text-xs md:text-sm px-6 whitespace-nowrap">
                  <i className="ri-water-flash-fill text-primary-400 mr-2"></i>
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}